import { makeStyles, Theme } from '@material-ui/core/styles'
import { createStyles } from '@material-ui/core'
import { colorSurfaceCoolGray } from '../../shared/style-settings'

export const useListedItemDetailsComponentStyles = makeStyles((theme: Theme) =>
  createStyles({
    pageSurface: {
      backgroundColor: colorSurfaceCoolGray,
      minHeight: '100%',
      paddingBottom: theme.spacing(4),
    },
    mainHolder: {
      padding: theme.spacing(4, 3, 5),
      marginTop: theme.spacing(2),
      [theme.breakpoints.up('md')]: {
        padding: theme.spacing(5, 4, 6),
      },
    },
  })
)
